import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  standalone: false,
})
export class LoaderComponent {
  constructor(private loaderService: LoaderService) {}

  get isLoading() {
    return this.loaderService.isLoading();
  }
}
